import { WorkingCenterModelType } from '@teinor/erp/types/company/workingCenter'
import { ComponentWithPermissions } from '../../../../../../../../../baseComponents/CreateRoutering/types'
import TwinTable from '../../../../../../../../../baseComponents/TwinTable'
import BaseScreenTableInner from '../../../../../../../../../baseComponents/TwinTable/BaseScreenTableInner'
import { TableComponentBaseScreenInnerProps } from '../../../../../../../../../baseComponents/TwinTable/BaseScreenTableInner/types'
import { ColumnTableSchema } from '../../../../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import useTwinTranslation from '../../../../../../../../../utils/hooks/useTwinTranslation'
import { permissionCheck } from '../../../../../../../../../baseComponents/PermissionChecker/function'
import { CustomRenderBoolean, DeleteRow, EditRowNotLink } from '../../../../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import ModalCEWorkingCenterStation from './ModalCEWorkingCenterStation'
import ModalDeleteWorkingCenterStation from './ModalDeleteWorkingCenterStation'
import { WorkingCenterStationModelType } from '@teinor/erp/types/company/workingCenter/workingCenterStation'
import { faRotateLeft } from '@fortawesome/pro-light-svg-icons'

interface WorkingCenterStationsProps extends ComponentWithPermissions {
    basicData: WorkingCenterModelType
}

const WorkingCenterStations: React.FC<WorkingCenterStationsProps> = ({ basicData, userPermissions }) => {
    const { t } = useTwinTranslation()

    const pageData = {
        title: t('workStations', 'Puestos'),
        newText: t('createWorkStation', 'Crear puesto'),
    }

    return (
        <BaseScreenTableInner TableComponent={TableWorkingCenterStations} CreateModalComponent={ModalCEWorkingCenterStation} EditModalComponent={ModalCEWorkingCenterStation} pageData={pageData} userPermissions={userPermissions} extraWhereParams={{ WorkingCenterId: basicData.id }} DeleteModalComponent={ModalDeleteWorkingCenterStation} />
    )
}

interface TableWorkingCenterStationsProps extends TableComponentBaseScreenInnerProps { }


const TableWorkingCenterStations: React.FC<TableWorkingCenterStationsProps> = ({ setOpened, setTableInstance, userPermissions, extraWhereParams }) => {
    const { t } = useTwinTranslation()
    const columns: ColumnTableSchema<WorkingCenterStationModelType> = [
        {
            id: 'id',
            dataKey: 'id',
            label: t('id', 'ID'),
            width: 80,
        },
        {
            id: 'name',
            dataKey: 'name',
            label: t('name', 'Nombre'),
        },
        {
            id: 'active',
            dataKey: 'active',
            label: t('active', 'Activo'),
            customRender: (parameterValue) => <CustomRenderBoolean value={String(parameterValue) === 'true'} width={45} />,
            hideColumnByDefault: true,
            searchableComponent: {
                component: 'SearchableComponentsCustomSelectSingle',
                extraComponentData: {
                    items: {
                        'true': { name: t('actived', 'Activados') },
                        'false': { name: t('disabled', 'Desactivados') },
                        'all': { name: t('all', 'Todos') }
                    }, label: t('active', 'Activo')
                }
            },
            searchKey: 'active',
            generalSearchable: false
        },
        {
            id: 'edit',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('edit', 'Editar'),
            customRender: (parameterValue, allRowData) => <EditRowNotLink key={'edit' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'edit', allRowData })} />
        },
        {
            id: 'delete',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('delete', 'Eliminar'),
            customRender: (parameterValue, allRowData) => {
                const icon = !allRowData?.active ? faRotateLeft : undefined
                return <DeleteRow key={'delete' + parameterValue} {...{ icon, parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'delete', allRowData })} />
            },
            havePermission: permissionCheck(userPermissions, 'delete')
        }
    ]
    return (
        <TwinTable columns={columns} name='workingCenterStations' getDataFrom='/api/app/workingCenter/workingCenterStation/getAllWorkingCenterStations'
            onRowClick={(_id, rowData) => setOpened({
                type: 'edit',
                allRowData: rowData
            })} setTableInstance={setTableInstance} extraWhereParams={extraWhereParams} />
    )
}

export default WorkingCenterStations